var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactComponent as AstronautX } from '@backrs_ui/common-ui/src/assets/images/astronaut-x.svg';
import { ReactComponent as BackrsFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { ReactComponent as BackrsLogoSmall } from '@backrs_ui/common-ui/src/assets/images/backrs-logo-small.svg';
import { ReactComponent as BackrsWithText } from '@backrs_ui/common-ui/src/assets/images/backrs-with-text.svg';
import { ReactComponent as BlueprintTextOnly } from '@backrs_ui/common-ui/src/assets/images/blueprint-text-only.svg';
import { ReactComponent as IconApply } from '@backrs_ui/common-ui/src/assets/images/icon-apply.svg';
import { ReactComponent as IconArrowOpenRight } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-open-right.svg';
import { ReactComponent as IconArrowOut } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-out.svg';
import { ReactComponent as IconArrowRight } from '@backrs_ui/common-ui/src/assets/images/icon-arrow-right.svg';
import { ReactComponent as IconArticle } from '@backrs_ui/common-ui/src/assets/images/icon-article.svg';
import { ReactComponent as IconAudio } from '@backrs_ui/common-ui/src/assets/images/icon-audio.svg';
import { ReactComponent as IconBook } from '@backrs_ui/common-ui/src/assets/images/icon-book.svg';
import { ReactComponent as IconBookmarkFilled } from '@backrs_ui/common-ui/src/assets/images/icon-bookmark-filled.svg';
import { ReactComponent as IconBookmark } from '@backrs_ui/common-ui/src/assets/images/icon-bookmark.svg';
import { ReactComponent as IconBriefcase } from '@backrs_ui/common-ui/src/assets/images/icon-briefcase.svg';
import { ReactComponent as IconBuilding } from '@backrs_ui/common-ui/src/assets/images/icon-building.svg';
import { ReactComponent as IconBusOff } from '@backrs_ui/common-ui/src/assets/images/icon-bus-off.svg';
import { ReactComponent as IconBusiness } from '@backrs_ui/common-ui/src/assets/images/icon-business.svg';
import { ReactComponent as IconChecked } from '@backrs_ui/common-ui/src/assets/images/icon-checked.svg';
import { ReactComponent as IconClipboardPlus } from '@backrs_ui/common-ui/src/assets/images/icon-clipboard-plus.svg';
import { ReactComponent as IconClipboard } from '@backrs_ui/common-ui/src/assets/images/icon-clipboard.svg';
import { ReactComponent as IconClose } from '@backrs_ui/common-ui/src/assets/images/icon-close.svg';
import { ReactComponent as IconComingSoon } from '@backrs_ui/common-ui/src/assets/images/icon-coming-soon.svg';
import { ReactComponent as IconCopy } from '@backrs_ui/common-ui/src/assets/images/icon-copy.svg';
import { ReactComponent as IconDocument } from '@backrs_ui/common-ui/src/assets/images/icon-document.svg';
import { ReactComponent as IconDownChevronCircle } from '@backrs_ui/common-ui/src/assets/images/icon-down-chevron-circle.svg';
import { ReactComponent as IconDownload } from '@backrs_ui/common-ui/src/assets/images/icon-download.svg';
import { ReactComponent as IconDropdown } from '@backrs_ui/common-ui/src/assets/images/icon-dropdown.svg';
import { ReactComponent as IconEdit } from '@backrs_ui/common-ui/src/assets/images/icon-edit.svg';
import { ReactComponent as IconEvent } from '@backrs_ui/common-ui/src/assets/images/icon-event.svg';
import { ReactComponent as IconFlag } from '@backrs_ui/common-ui/src/assets/images/icon-flag.svg';
import { ReactComponent as IconGear } from '@backrs_ui/common-ui/src/assets/images/icon-gear.svg';
import { ReactComponent as IconGoal } from '@backrs_ui/common-ui/src/assets/images/icon-goal.svg';
import { ReactComponent as IconHashtag } from '@backrs_ui/common-ui/src/assets/images/icon-hashtag.svg';
import { ReactComponent as IconHeadshot } from '@backrs_ui/common-ui/src/assets/images/icon-headshot.svg';
import { ReactComponent as IconHistory } from '@backrs_ui/common-ui/src/assets/images/icon-history.svg';
import { ReactComponent as IconInstitution } from '@backrs_ui/common-ui/src/assets/images/icon-institution.svg';
import { ReactComponent as IconLevelOne } from '@backrs_ui/common-ui/src/assets/images/icon-level-one.svg';
import { ReactComponent as IconLevelTwo } from '@backrs_ui/common-ui/src/assets/images/icon-level-two.svg';
import { ReactComponent as IconLineArrowLeft } from '@backrs_ui/common-ui/src/assets/images/icon-line-arrow-left.svg';
import { ReactComponent as IconLineArrowRight } from '@backrs_ui/common-ui/src/assets/images/icon-line-arrow-right.svg';
import { ReactComponent as IconList } from '@backrs_ui/common-ui/src/assets/images/icon-list.svg';
import { ReactComponent as IconMap } from '@backrs_ui/common-ui/src/assets/images/icon-map.svg';
import { ReactComponent as IconMessageExclamationMark } from '@backrs_ui/common-ui/src/assets/images/icon-message-exclamation-mark.svg';
import { ReactComponent as IconOfficeChairPlus } from '@backrs_ui/common-ui/src/assets/images/icon-office-chair-plus.svg';
import { ReactComponent as IconOfficeChair } from '@backrs_ui/common-ui/src/assets/images/icon-office-chair.svg';
import { ReactComponent as IconOpportunity } from '@backrs_ui/common-ui/src/assets/images/icon-opportunity.svg';
import { ReactComponent as IconPaperRole } from '@backrs_ui/common-ui/src/assets/images/icon-paper-role.svg';
import { ReactComponent as IconPlayButton } from '@backrs_ui/common-ui/src/assets/images/icon-play-button.svg';
import { ReactComponent as IconPlusBlue } from '@backrs_ui/common-ui/src/assets/images/icon-plus-sign.svg';
import { ReactComponent as IconPlusWhiteBlueCircle } from '@backrs_ui/common-ui/src/assets/images/icon-plus-white-blue-circle.svg';
import { ReactComponent as IconProfileExternal } from '@backrs_ui/common-ui/src/assets/images/icon-profile-external.svg';
import { ReactComponent as IconProfileInternal } from '@backrs_ui/common-ui/src/assets/images/icon-profile-internal.svg';
import { ReactComponent as IconQuestionMark } from '@backrs_ui/common-ui/src/assets/images/icon-question-mark.svg';
import { ReactComponent as IconQuotationLarge } from '@backrs_ui/common-ui/src/assets/images/icon-quotation-large.svg';
import { ReactComponent as IconRefresh } from '@backrs_ui/common-ui/src/assets/images/icon-refresh.svg';
import { ReactComponent as IconScholarship } from '@backrs_ui/common-ui/src/assets/images/icon-scholarship.svg';
import { ReactComponent as IconSearch } from '@backrs_ui/common-ui/src/assets/images/icon-search.svg';
import { ReactComponent as IconSend } from '@backrs_ui/common-ui/src/assets/images/icon-send.svg';
import { ReactComponent as IconSupercoach } from '@backrs_ui/common-ui/src/assets/images/icon-supercoach.svg';
import { ReactComponent as IconSuperuser } from '@backrs_ui/common-ui/src/assets/images/icon-superuser.svg';
import { ReactComponent as IconTextResponse } from '@backrs_ui/common-ui/src/assets/images/icon-text-response.svg';
import { ReactComponent as IconTrainTrack } from '@backrs_ui/common-ui/src/assets/images/icon-train-track.svg';
import { ReactComponent as IconTwoArrows } from '@backrs_ui/common-ui/src/assets/images/icon-two-arrows.svg';
import { ReactComponent as IconUnchecked } from '@backrs_ui/common-ui/src/assets/images/icon-unchecked.svg';
import { ReactComponent as IconUncompleted } from '@backrs_ui/common-ui/src/assets/images/icon-uncompleted.svg';
import { ReactComponent as IconUniversity } from '@backrs_ui/common-ui/src/assets/images/icon-university.svg';
import { ReactComponent as IconUpload } from '@backrs_ui/common-ui/src/assets/images/icon-upload.svg';
import { ReactComponent as IconVideo } from '@backrs_ui/common-ui/src/assets/images/icon-video.svg';
import { ReactComponent as LubavBubble } from '@backrs_ui/common-ui/src/assets/images/lubav-bubble.svg';
import { ReactComponent as LubavFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/lubav-filled-drop-shadow.svg';
import { ReactComponent as LubavLogoWithText } from '@backrs_ui/common-ui/src/assets/images/lubav-logo-with-text.svg';
import { ReactComponent as LubavLogo } from '@backrs_ui/common-ui/src/assets/images/lubav-logo.svg';
import { ReactComponent as ModuleLevelOne } from '@backrs_ui/common-ui/src/assets/images/module-level-one.svg';
import { ReactComponent as ModuleLevelTwo } from '@backrs_ui/common-ui/src/assets/images/module-level-two.svg';
import { ReactComponent as ModuleUncompleted } from '@backrs_ui/common-ui/src/assets/images/module-uncompleted.svg';
import { ReactComponent as MyAccountLogo } from '@backrs_ui/common-ui/src/assets/images/my-account-logo.svg';
import { ReactComponent as IconPhone } from '@backrs_ui/common-ui/src/assets/images/phone_call_fill.svg';
import { ReactComponent as IconPlusWhite } from '@backrs_ui/common-ui/src/assets/images/plus.svg';
import { ReactComponent as ProsperFilledDropShadow } from '@backrs_ui/common-ui/src/assets/images/prosper-filled-drop-shadow.svg';
import { ReactComponent as ProsperLogo } from '@backrs_ui/common-ui/src/assets/images/prosper-logo.svg';
import { ReactComponent as IconSolutionSession } from '@backrs_ui/common-ui/src/assets/images/solution-session-icon.svg';
import { ReactComponent as CollegeShortlistIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/college_shortlist.svg';
import { ReactComponent as CommonThreadsIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/common_threads.svg';
import { ReactComponent as ImproveYourTestScoresIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/improve_your_test_scores.svg';
import { ReactComponent as JobsYouMightLoveIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/jobs_you_might_love.svg';
import { ReactComponent as LettersOfRecommendationIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/letters_of_rec.svg';
import { ReactComponent as LowerCostOfCollegeIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/lower_cost_of_college.svg';
import { ReactComponent as WhatAreYourChancesIcon } from '@backrs_ui/common-ui/src/assets/images/solution-session-icons/what_are_your_chances.svg';
import { ReactComponent as IconUserSwitch } from '@backrs_ui/common-ui/src/assets/images/user-switch.svg';
export var BackrsIconMap = {
    AstronautX: AstronautX,
    IconApply: IconApply,
    IconArticle: IconArticle,
    IconAudio: IconAudio,
    IconArrowRight: IconArrowRight,
    IconArrowOpenRight: IconArrowOpenRight,
    IconArrowOut: IconArrowOut,
    IconBusiness: IconBusiness,
    IconBuilding: IconBuilding,
    IconBook: IconBook,
    IconBookmarkFilled: IconBookmarkFilled,
    IconBookmark: IconBookmark,
    IconBusOff: IconBusOff,
    IconBriefcase: IconBriefcase,
    IconClipboard: IconClipboard,
    IconClipboardPlus: IconClipboardPlus,
    IconClose: IconClose,
    IconComingSoon: IconComingSoon,
    IconCopy: IconCopy,
    IconDocument: IconDocument,
    IconDownChevronCircle: IconDownChevronCircle,
    IconDropdown: IconDropdown,
    IconEvent: IconEvent,
    IconHeadshot: IconHeadshot,
    IconMessageExclamationMark: IconMessageExclamationMark,
    IconFlag: IconFlag,
    IconGear: IconGear,
    IconGoal: IconGoal,
    IconHashtag: IconHashtag,
    IconHistory: IconHistory,
    IconInstitution: IconInstitution,
    IconLineArrowLeft: IconLineArrowLeft,
    IconLineArrowRight: IconLineArrowRight,
    IconList: IconList,
    IconMap: IconMap,
    IconPlayButton: IconPlayButton,
    IconPaperRole: IconPaperRole,
    IconOfficeChair: IconOfficeChair,
    IconOfficeChairPlus: IconOfficeChairPlus,
    IconOpportunity: IconOpportunity,
    IconTrainTrack: IconTrainTrack,
    IconScholarship: IconScholarship,
    IconSearch: IconSearch,
    IconSend: IconSend,
    IconTextResponse: IconTextResponse,
    IconTwoArrows: IconTwoArrows,
    IconLevelOne: IconLevelOne,
    IconLevelTwo: IconLevelTwo,
    IconProfileExternal: IconProfileExternal,
    IconProfileInternal: IconProfileInternal,
    IconQuotationLarge: IconQuotationLarge,
    IconQuestionMark: IconQuestionMark,
    IconUncompleted: IconUncompleted,
    IconChecked: IconChecked,
    IconUnchecked: IconUnchecked,
    IconVideo: IconVideo,
    IconUniversity: IconUniversity,
    IconSolutionSession: IconSolutionSession,
    IconPhone: IconPhone,
    IconPlusWhite: IconPlusWhite,
    IconPlusBlue: IconPlusBlue,
    IconPlusWhiteBlueCircle: IconPlusWhiteBlueCircle,
    IconUserSwitch: IconUserSwitch,
    BlueprintTextOnly: BlueprintTextOnly,
    LubavLogoWithText: LubavLogoWithText,
    LubavLogo: LubavLogo,
    LubavBubble: LubavBubble,
    IconSupercoach: IconSupercoach,
    IconSuperuser: IconSuperuser,
    ModuleLevelOne: ModuleLevelOne,
    LubavFilledDropShadow: LubavFilledDropShadow,
    ModuleLevelTwo: ModuleLevelTwo,
    ModuleUncompleted: ModuleUncompleted,
    ProsperLogo: ProsperLogo,
    ProsperFilledDropShadow: ProsperFilledDropShadow,
    BackrsFilledDropShadow: BackrsFilledDropShadow,
    BackrsLogoSmall: BackrsLogoSmall,
    BackrsWithText: BackrsWithText,
    MyAccountLogo: MyAccountLogo,
    IconRefresh: IconRefresh,
    IconEdit: IconEdit,
    IconDownload: IconDownload,
    IconUpload: IconUpload,
    CollegeShortlistIcon: CollegeShortlistIcon,
    WhatAreYourChancesIcon: WhatAreYourChancesIcon,
    ImproveYourTestScoresIcon: ImproveYourTestScoresIcon,
    LowerCostOfCollegeIcon: LowerCostOfCollegeIcon,
    JobsYouMightLoveIcon: JobsYouMightLoveIcon,
    CommonThreadsIcon: CommonThreadsIcon,
    LettersOfRecommendationIcon: LettersOfRecommendationIcon,
};
var ICON_TYPES = {
    AstronautX: AstronautX,
    IconApply: IconApply,
    IconArticle: IconArticle,
    IconAudio: IconAudio,
    IconArrowRight: IconArrowRight,
    IconArrowOpenRight: IconArrowOpenRight,
    IconArrowOut: IconArrowOut,
    IconBook: IconBook,
    IconBookmarkFilled: IconBookmarkFilled,
    IconBookmark: IconBookmark,
    IconBuilding: IconBuilding,
    IconBusiness: IconBusiness,
    IconBusOff: IconBusOff,
    IconBriefcase: IconBriefcase,
    IconClipboard: IconClipboard,
    IconClipboardPlus: IconClipboardPlus,
    IconClose: IconClose,
    IconComingSoon: IconComingSoon,
    IconCopy: IconCopy,
    IconDownChevronCircle: IconDownChevronCircle,
    IconDocument: IconDocument,
    IconDropdown: IconDropdown,
    IconEvent: IconEvent,
    IconFlag: IconFlag,
    IconMessageExclamationMark: IconMessageExclamationMark,
    IconGoal: IconGoal,
    IconGear: IconGear,
    IconHeadshot: IconHeadshot,
    IconHashtag: IconHashtag,
    IconHistory: IconHistory,
    IconInstitution: IconInstitution,
    IconLineArrowLeft: IconLineArrowLeft,
    IconLineArrowRight: IconLineArrowRight,
    IconList: IconList,
    IconMap: IconMap,
    IconOfficeChair: IconOfficeChair,
    IconOfficeChairPlus: IconOfficeChairPlus,
    IconPlayButton: IconPlayButton,
    IconPaperRole: IconPaperRole,
    IconPlusBlue: IconPlusBlue,
    IconPlusWhiteBlueCircle: IconPlusWhiteBlueCircle,
    IconOpportunity: IconOpportunity,
    IconScholarship: IconScholarship,
    IconTrainTrack: IconTrainTrack,
    IconTextResponse: IconTextResponse,
    IconLevelOne: IconLevelOne,
    IconLevelTwo: IconLevelTwo,
    IconSearch: IconSearch,
    IconSend: IconSend,
    IconPhone: IconPhone,
    IconProfileExternal: IconProfileExternal,
    IconProfileInternal: IconProfileInternal,
    IconQuotationLarge: IconQuotationLarge,
    IconTwoArrows: IconTwoArrows,
    IconUncompleted: IconUncompleted,
    IconUnchecked: IconUnchecked,
    IconQuestionMark: IconQuestionMark,
    IconUniversity: IconUniversity,
    IconSupercoach: IconSupercoach,
    IconSuperuser: IconSuperuser,
    IconChecked: IconChecked,
    IconVideo: IconVideo,
    IconSolutionSession: IconSolutionSession,
    IconPlusWhite: IconPlusWhite,
    IconUserSwitch: IconUserSwitch,
    BlueprintTextOnly: BlueprintTextOnly,
    ModuleLevelOne: ModuleLevelOne,
    ModuleLevelTwo: ModuleLevelTwo,
    ModuleUncompleted: ModuleUncompleted,
    LubavLogoWithText: LubavLogoWithText,
    LubavLogo: LubavLogo,
    LubavBubble: LubavBubble,
    LubavFilledDropShadow: LubavFilledDropShadow,
    ProsperFilledDropShadow: ProsperFilledDropShadow,
    ProsperLogo: ProsperLogo,
    BackrsFilledDropShadow: BackrsFilledDropShadow,
    BackrsLogoSmall: BackrsLogoSmall,
    BackrsWithText: BackrsWithText,
    MyAccountLogo: MyAccountLogo,
    IconRefresh: IconRefresh,
    IconEdit: IconEdit,
    IconDownload: IconDownload,
    IconUpload: IconUpload,
    CollegeShortlistIcon: CollegeShortlistIcon,
    WhatAreYourChancesIcon: WhatAreYourChancesIcon,
    ImproveYourTestScoresIcon: ImproveYourTestScoresIcon,
    LowerCostOfCollegeIcon: LowerCostOfCollegeIcon,
    JobsYouMightLoveIcon: JobsYouMightLoveIcon,
    CommonThreadsIcon: CommonThreadsIcon,
    LettersOfRecommendationIcon: LettersOfRecommendationIcon,
};
export var BackrsIcon = function (_a) {
    var name = _a.name, alt = _a.alt, color = _a.color, _b = _a.opacity, opacity = _b === void 0 ? 1 : _b, height = _a.height, width = _a.width, style = _a.style;
    var IconComponent = ICON_TYPES[name];
    return (_jsx(IconComponent, __assign({ "aria-label": alt, color: color, opacity: opacity }, (height && { height: height }), (width && { width: width }), (style && { style: style }))));
};
